import React, { useState, memo } from "react";
import { useTranslation } from "react-i18next";
import { Props, State, NotificationStatusQuickFilter } from "./interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const NotificationStatusQuickfilter = <Q extends NotificationStatusQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.notification_status";

  const [options] = useState<State>({
    customOptions: [],
    computedOptions: [
      {
        name: t(`${tRP}.all`),
        value: { isNotified: null },
      },
      {
        name: t(`${tRP}.notified`),
        value: { isNotified: true },
      },
      {
        name: t(`${tRP}.not_notified`),
        value: { isNotified: false },
      },
    ],
  });

  return (
    <QuickFilter
      options={[...options.customOptions, ...options.computedOptions] as any}
      quickFilters={quickFilters}
      quickFilter="notificationStatus"
      handleChangeQuickFilter={handleChangeQuickFilters}
      defaultLabel={t(`${tRP}.default_label`)}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
      customLabelStyle={{ minWidth: "120px" }}
      // customWidth="250px"
    />
  );
};

export default memo(NotificationStatusQuickfilter);
